import OtpInput from 'react-otp-input';
import { borders } from '../../../Enums';
import React, { Component } from 'react';

class OtpComponent extends Component {
  state = {
    endTime: null,
    minutes: 3,
    seconds: 0
  };

  componentDidMount() {
    this.setState(
      { endTime: this.props.globalData.otpData.data.expiration_time },
      this.timerCounter
    );
  }

  timerCounter = () => {
    let endTime = this.state.endTime;
    let now = new Date().getTime();
    let distance = endTime - now;
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (minutes > 0 || seconds >= 0) {
      this.setState({ minutes: minutes, seconds: seconds });
      setTimeout(this.timerCounter, 1000);
    } else {
    }
  };

  render() {
    let gs = this.props.gs;
    let gc = this.props.gc;
    let guc = this.props.guc;

    return (
      <div style={{ marginTop: '5px' }}>
        <OtpInput
          onChange={this.props.changeOtp}
          numInputs={6}
          value={this.props.otp}
          inputStyle={{
            ...gs('otp_input'),
            border: borders.NORMAL_BORDER
          }}
          separator={<span style={{ width: '20px' }}> </span>}
        />

        {this.state.endTime && (
          <div style={{ ...gs('form_small_text'), marginTop: '3px' }}>
            {gc('otp_expires_in') + ': ' +
              this.state.minutes + ' ' +
            gc('minutes') + ' ' +
              this.state.seconds + ' ' +
              gc('seconds')}
          </div>
        )}
      </div>
    );
  }
}

export default OtpComponent;
